let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lpSm6")).then(() => parcelRequire('9ezP1'));